var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"data-table-header"},[_c('tr',_vm._l((_vm.headers),function(h){return _c('th',{key:h.value},[_vm._v(_vm._s(h.label))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }